<template>
  <div class="support-page">
     <!-- 父 div 左上角 -->
    <h1 class="page-title">{{ $t('nav.service_support') }}</h1>

    <div class="card">
      <p class="desc">{{ $t('support.desc') }}</p>

      <div class="contact-section">
        <div class="contact-item">
          <div class="label">{{ $t('support.phone') }}</div>
          <a :href="'tel:' + phone" class="contact-value">
            {{ phone }}
          </a>
        </div>
      </div>
    </div>

  </div>
</template>


<script>
export default {
  name: "ServiceSupport",
  data() {
    return {
      phone: "+86 18665886416",
    };
  },
};
</script>
<style scoped>
.support-page {
  
  width: 100%;
  min-height: 70vh;
  background: #f5f6fa;
  padding: 40px 20px;
 

}

/* 标题放父div左上角 */
.page-title {
  display: flex;
  flex-direction: column;
  align-items: flex-start; 
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin: 0 60px;
}

/* 卡片主体 */
.card {
  background: #fff;
  padding: 30px 40px;
  border-radius: 16px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
  max-width: 480px;
  width: 100%;
  margin: 60px auto;     /* 给顶部标题留空间 */
  display: flex;
  flex-direction: column;
  align-items: center; 
}

.desc {
  text-align: left;
  font-size: 15px;
  color: #666;
  margin-bottom: 25px;
}

.contact-item {
  background: #f8faff;
  border: 1px solid #e6ecf5;
  padding: 15px 20px;
  border-radius: 12px;
}

.label {
  font-size: 14px;
  color: #999;
}

.contact-value {
  font-size: 20px;
  font-weight: 600;
  text-decoration: none;
  color: #409eff;
}
</style>

